const WORDS_PER_MINUTE = 220;

export const countReadableWords = (text = "") => {
  const matches = String(text).trim().match(/\S+/g);
  return matches ? matches.length : 0;
};

export const getLessonWordCount = (lesson = {}) => {
  const safeLesson = lesson || {};

  if (Number.isFinite(safeLesson.readingWordCount)) {
    return safeLesson.readingWordCount;
  }

  return countReadableWords(safeLesson.body);
};

export const formatReadingEstimate = (lesson = {}) => {
  const wordCount = getLessonWordCount(lesson);

  if (wordCount <= 0) {
    return "";
  }

  const totalMinutes = Math.max(1, Math.ceil(wordCount / WORDS_PER_MINUTE));

  if (totalMinutes < 60) {
    return `${totalMinutes} min`;
  }

  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  return minutes
    ? `${hours}h ${minutes}m`
    : `${hours}h`;
};
